import CountryService from '../../services/CountryService';
import { IValueLabelPair } from '../../modules/Form/Select';

export const getDeliveryCountriesOptions = (countries: GQL.ICountry[], invoiceCountry: GQL.ICountry | undefined): IValueLabelPair[] => {
    const { country, isEUMember, getEUMembers } = CountryService.GetInstance();

    const isEU = isEUMember(invoiceCountry && invoiceCountry.code ? invoiceCountry.code : country.code || '');

    const invoiceBusinessId = invoiceCountry?.business?.id || country.business?.id;

    // Find delivery countries based on region where I am EU/non-EU
    return getEUMembers(countries || [], isEU)
      .filter((c: GQL.ICountry) => !!c.code)
      // Allow delivery only to Canada if billing is in Canada
      .filter((c: GQL.ICountry) => (invoiceCountry?.name === 'Canada' ? c.name === 'Canada' : true))
      // Allow delivery only to countries operated by the same business as in a billing country
      .filter((c: GQL.ICountry) => (c.business && invoiceBusinessId) ? c.business.id === invoiceBusinessId : true)
      .map((c: GQL.ICountry) => ({ value: c.name, label: c.name }));
};



// WEBPACK FOOTER //
// ./src/helpers/address/getDeliveryCountriesOptions.ts